import { Step } from '@features/create-entity-modal/types';

import { step1Schema, step2SchemaRefined, step3Schema } from '../validation';

export const getValidationSchema = (currentStep: Step) => {
  switch (currentStep) {
    case Step.GeneralEntityData:
      return step1Schema;

    case Step.BaseEntityData:
      return step2SchemaRefined;

    default:
      return step3Schema;
  }
};
